import React from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import MdClose from 'react-icons/lib/md/close'
import { toggleStreetView } from '../../store/Actions/UiActions'

const CloseStreetView = ({ toggleStreetView, theme }) => (
  <div className="close-street-view" onClick={() => toggleStreetView(false)}>
    <MdClose color={theme} />
  </div>
)

CloseStreetView.propTypes = {
  toggleStreetView: func.isRequired,
  theme: string.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  theme: spi.theme,
})

const mapDispatchToProps = dispatch => ({
  toggleStreetView: value => dispatch(toggleStreetView(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CloseStreetView)



// WEBPACK FOOTER //
// ./src/components/StreetView/CloseStreetView.jsx